/** @format */

import Navbar from "./component/Navbar";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./component/Login";
import Signup from "./component/Signup";
import AuthContextProvider from "./context/AuthContext";
import AdminLogin from "./component/AdminLogin";
import ProfileUpdatePage from "./pages/profile/ProfileUpdatePage";
import ProfilePage from "./pages/profile/ProfilePage";
import Toast from "./component/Toast";
import PrivateRoute from "./component/PrivateRoute";
import Modal from "./component/Modal";

function App() {
  return (
    <AuthContextProvider>
      <div className="app">
        <Modal />
        <Navbar />
        <Toast />
        <Login />
        <AdminLogin />
        <Signup />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/profile-update"
            element={
              <PrivateRoute>
                <ProfileUpdatePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
                {" "}
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </AuthContextProvider>
  );
}

export default App;
